import { render } from "./DashboardTable.vue?vue&type=template&id=3f5b581d"
import script from "./DashboardTable.vue?vue&type=script&lang=js"
export * from "./DashboardTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__